import { render, staticRenderFns } from "./UsersBisnisUnitEdit.vue?vue&type=template&id=14a9f132&lang=pug"
import script from "./UsersBisnisUnitEdit.vue?vue&type=script&lang=js"
export * from "./UsersBisnisUnitEdit.vue?vue&type=script&lang=js"
import style0 from "./UsersBisnisUnitEdit.vue?vue&type=style&index=0&id=14a9f132&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports